'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cancelGenericSettings = exports.saveGenericSettings = exports.getGenericSettings = exports.CANCEL = exports.SAVE_GENERICSETTINGS_TYPES = exports.GET_GENERICSETTINGS_TYPES = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.fetchGenericSettingsSaga = fetchGenericSettingsSaga;
exports.saveGenericSettingsSaga = saveGenericSettingsSaga;
exports.watchGetGenericSettings = watchGetGenericSettings;
exports.watchSaveGenericSettings = watchSaveGenericSettings;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _fetchStatusTypes = require('constants/fetchStatusTypes');

var STATUS = _interopRequireWildcard(_fetchStatusTypes);

var _api = require('helpers/api');

var _api2 = _interopRequireDefault(_api);

var _createFetchTypes = require('../../utils/createFetchTypes');

var _createFetchTypes2 = _interopRequireDefault(_createFetchTypes);

var _fetchEntitySagaAuth = require('../../utils/fetchEntitySagaAuth');

var _fetchEntitySagaAuth2 = _interopRequireDefault(_fetchEntitySagaAuth);

var _notifications = require('../notifications');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchGenericSettingsSaga),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(saveGenericSettingsSaga),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchGetGenericSettings),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(watchSaveGenericSettings);

var GET_GENERICSETTINGS_TYPES = exports.GET_GENERICSETTINGS_TYPES = (0, _createFetchTypes2.default)('tq-plus-admin/genericSettings/GET_GENERICSETTINGS');

var SAVE_GENERICSETTINGS_TYPES = exports.SAVE_GENERICSETTINGS_TYPES = (0, _createFetchTypes2.default)('tq-plus-admin/genericSettings/SAVE_GENERICSETTINGS_TYPES');

var CANCEL = exports.CANCEL = 'tq-plus-admin/genericSettings/CANCEL';

var initialState = {
    isLoading: false,
    error: null,
    genericSettingsStatus: STATUS.UNRETRIEVED,
    temp: {},
    current: {}
};

/* REDUCER
 * ---------------------------------------------------------------------------------------------- */
function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case GET_GENERICSETTINGS_TYPES.REQUEST:
            return (0, _extends3.default)({}, state, {
                isLoading: true,
                genericSettingsStatus: STATUS.REQUESTING
            });
        case GET_GENERICSETTINGS_TYPES.SUCCESS:
            return (0, _extends3.default)({}, state, {
                isLoading: false,
                error: null,
                genericSettingsStatus: STATUS.SUCCEEDED,
                current: action.genericSettings || {},
                temp: action.genericSettings || {}
            });
        case GET_GENERICSETTINGS_TYPES.FAILURE:
            return (0, _extends3.default)({}, state, {
                genericSettingsStatus: STATUS.FAILED,
                isLoading: false,
                error: action.error
            });

        case SAVE_GENERICSETTINGS_TYPES.REQUEST:
            return (0, _extends3.default)({}, state, { isLoading: true });
        case SAVE_GENERICSETTINGS_TYPES.SUCCESS:
            return (0, _extends3.default)({}, state, {
                isLoading: false,
                error: null,
                areSettingsLoaded: true
            });
        case SAVE_GENERICSETTINGS_TYPES.FAILURE:
            return (0, _extends3.default)({}, state, { isLoading: false, error: action.error });
        case CANCEL:
            return (0, _extends3.default)({}, state);
        default:
            return state;
    }
}

/* ACTIONS
 * ---------------------------------------------------------------------------------------------- */
var getGenericSettings = exports.getGenericSettings = {
    base: function base(codedToken) {
        return {
            type: GET_GENERICSETTINGS_TYPES.BASE,
            url: 'generic-settings/get-settings',
            token: codedToken
        };
    },
    request: function request() {
        return { type: GET_GENERICSETTINGS_TYPES.REQUEST };
    },
    success: function success(genericSettings) {
        return { type: GET_GENERICSETTINGS_TYPES.SUCCESS, genericSettings: genericSettings };
    },
    failure: function failure(error) {
        return { type: GET_GENERICSETTINGS_TYPES.FAILURE, error: error };
    }
};

var saveGenericSettings = exports.saveGenericSettings = {
    base: function base(genericSettings, codedToken) {
        return {
            type: SAVE_GENERICSETTINGS_TYPES.BASE,
            url: 'generic-settings/save-settings',
            data: { genericSettings: genericSettings },
            token: codedToken
        };
    },
    request: function request() {
        return { type: SAVE_GENERICSETTINGS_TYPES.REQUEST };
    },
    success: function success(genericSettings) {
        return { type: SAVE_GENERICSETTINGS_TYPES.SUCCESS, genericSettings: genericSettings };
    },
    failure: function failure(error) {
        return { type: SAVE_GENERICSETTINGS_TYPES.FAILURE, error: error };
    }
};

var cancelGenericSettings = exports.cancelGenericSettings = function cancelGenericSettings() {
    return { type: CANCEL };
};

/* SAGAS
 * ---------------------------------------------------------------------------------------------- */
function fetchGenericSettingsSaga(_ref) {
    var url = _ref.url,
        token = _ref.token;
    var result;
    return _regenerator2.default.wrap(function fetchGenericSettingsSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(function () {
                        return (0, _fetchEntitySagaAuth2.default)(getGenericSettings, _api2.default.get, url, { token: token });
                    });

                case 3:
                    result = _context.sent;
                    return _context.abrupt('return', result);

                case 7:
                    _context.prev = 7;
                    _context.t0 = _context['catch'](0);
                    _context.next = 11;
                    return (0, _effects.put)((0, _notifications.error)({
                        title: 'Error retrieving generic settings',
                        message: _context.t0.message
                    }));

                case 11:
                    return _context.abrupt('return', _context.t0);

                case 12:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 7]]);
}

function saveGenericSettingsSaga(_ref2) {
    var url = _ref2.url,
        data = _ref2.data,
        token = _ref2.token;
    var result;
    return _regenerator2.default.wrap(function saveGenericSettingsSaga$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(function () {
                        return (0, _fetchEntitySagaAuth2.default)(saveGenericSettings, _api2.default.post, url, { data: data, token: token });
                    });

                case 3:
                    result = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)((0, _notifications.success)({
                        title: 'Success',
                        message: 'Generic Settings have been saved correctly'
                    }));

                case 6:
                    _context2.next = 8;
                    return (0, _effects.put)(getGenericSettings.base(token));

                case 8:
                    return _context2.abrupt('return', result);

                case 11:
                    _context2.prev = 11;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 15;
                    return (0, _effects.put)((0, _notifications.error)({
                        title: 'Error saving generic settings',
                        message: _context2.t0.message
                    }));

                case 15:
                    return _context2.abrupt('return', _context2.t0);

                case 16:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 11]]);
}

// WATCHERS -----
function watchGetGenericSettings() {
    return _regenerator2.default.wrap(function watchGetGenericSettings$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    return _context3.delegateYield((0, _reduxSaga.takeLatest)(GET_GENERICSETTINGS_TYPES.BASE, fetchGenericSettingsSaga), 't0', 1);

                case 1:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this);
}

function watchSaveGenericSettings() {
    return _regenerator2.default.wrap(function watchSaveGenericSettings$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    return _context4.delegateYield((0, _reduxSaga.takeLatest)(SAVE_GENERICSETTINGS_TYPES.BASE, saveGenericSettingsSaga), 't0', 1);

                case 1:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this);
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/GenericSettings/genericSettings.js
// module id = 1658
// module chunks = 0